import * as CONST from '../common/const';
import api from 'utils/api';
import { logger } from '@amzn/awsui-components-react/polaris/internal/core/runtime/src';

export const fetchICDataRequest = () => {
  return {
    type: CONST.FETCH_ICDATA_REQUEST
  }
}

export const fetchICDataSuccess = (id, iCDataList) => {
  return {
    type: CONST.FETCH_ICDATA_SUCCESS,
    iCDataList: iCDataList,
    id: id
  }
}

export const fetchICDataFailure = (id, error) => {
  return {
    type: CONST.FETCH_ICDATA_FAILURE,
    error: error,
    id: id
  };
};


export const fetchICData = payload => async (dispatch, getState) => {

  dispatch(fetchICDataRequest());
  try {
    const result = await api.getICData(payload);
    dispatch(fetchICDataSuccess(payload.agreementNumber, result.ICLoanAndRoyalties));
  } catch (e) {
    dispatch(fetchICDataFailure(payload.agreementNumber, e));
  }
};